import React, { useState, useEffect } from 'react';
import BrandLogo from '../../../global/BrandLogo';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import './print-recipe.scss';
import { isValid, isText, decodeTags } from '../../../../utils';

const PrintRecipe = ({
    recipeData,
    title,
    isMobile,
    pubDate,
}) => {
    const makeArray = (data) => {
		let encodedData = decodeTags(data);
	    let dataArray = encodedData ? encodedData.split('</p>') : [];
	    for(var i = 0; i < dataArray.length; i++){ 
	    	if (!dataArray[i] || !dataArray[i].includes("<p")) {
	    		dataArray.splice(i, 1);
	    		break;
	    	} 
	    	dataArray[i]+='</p>';  
        }
        return dataArray;
	}

    let { name, credit, byline={}, imageSrcDesktop, imageSrcMobile, imageCredit, servings, average, numOfRatings, usePinterest = true, imagePinterestOverride, } = recipeData;
    let { prep, cook, total } = byline;
    let directionsArray = makeArray(recipeData.directions);
    let ingredientsArray = makeArray(recipeData.ingredients);

    const imageSrc = (isMobile && isValid(imageSrcMobile)) ? imageSrcMobile : isValid(imageSrcDesktop) ? imageSrcDesktop : null;

    const renderedIngredientList = ingredientsArray.map((ingredient, i) => (
        <li className="ingredient" dangerouslySetInnerHTML={ { __html: ingredient} } />
    ));
    const renderedDirections = directionsArray.map((direction, i) => (
        <div className="direction" dangerouslySetInnerHTML={ { __html: direction } } />
    ));

  return (
      <>
        <Helmet>
            <link rel="stylesheet" type="text/css" href="./print-recipt.scss" />
        </Helmet>
        <div className="print-recipe">
            <div className="print-recipe-header">
                <BrandLogo />
                <span className="print-button" onClick={() => window.print()}>PRINT</span>
            </div>
            <img className="recipe-img" src={imageSrc} />
            <h2 className="recipe-title">{name ? name : title}</h2>
            <div className="recipe-byline">
                <div className="pubDate"><span>{pubDate}</span></div>
                <div className="credit"><span>{credit}</span></div>
                <div className="servings"><span className="time">{servings}</span>{' '}<span>servings</span></div>
                <div className="total recipe-time"><span className="time">{total}</span></div>
            </div>
            <div className="ingredients-directions">
                <div className="ingredients">
                    <h2>Ingredients</h2>
                    <div className='ingredients recipe-list' id="ingredients-list">
                    {renderedIngredientList}
                    <div className="chicory-order-ingredients"></div>
                    </div>
                </div>
                <div className="directions">
                    <h2>Directions</h2>
                    <div className='directions recipe-list'>
                        {renderedDirections}
                    </div>
                </div>
            </div>
        </div>
      </>
  );
};

PrintRecipe.propTypes = {
    setShowPrintRecipe: PropTypes.func,
  };

export default PrintRecipe;
